module.exports = __webpack_public_path__ + "static/media/img_job.87a9b296.png";